import { FAQ } from './containers';
import './locales';

export const faqModule = {
  moduleName: 'FAQ',
  component: FAQ,
  reducer: null,
};
